export const ROOT = `/`;
export const AUTH_BASE = `${ROOT}auth/`;

export const ROUTES = {
  root: ROOT,
  auth: AUTH_BASE,
  authMfa: `${AUTH_BASE}mfa`,
  authNewPassword: `${AUTH_BASE}newpassword`,
  authResetPassword: `${AUTH_BASE}resetpassword`,
  authSubmitResetPassword: `${AUTH_BASE}submitresetpassword`,
  authSignOut: `${AUTH_BASE}logout`,
  portal: `${ROOT}portal`,
  info: `${ROOT}participant-information`,
  video: `${ROOT}participant-video`,
  sampleCollection: `${ROOT}sampleCollection`,
};

export default ROUTES;
